import { Type } from "../protocol/Type.mjs";
import { createMessage } from "./createMessage.mjs";
import { id } from "./id.mjs";
import { isWebView } from "./isWebView.mjs";
export class Plugin {
  constructor(logger, driver, stream) {
    this.logger = logger;
    this.driver = driver;
    this.stream = stream;
  }

  open({
    remote,
    app,
    path,
    height,
    disableClose,
    onClose
  }) {
    if (!isWebView()) {
      return this.logger.log('WARN', 'bridge.plugin.open', 'WebView 환경이 아닌 환경에서는 해당 함수를 지원하지 않아요');
    }

    const closeEventName = id();
    this.driver.postMessage(createMessage({
      type: Type.ReqPluginOpen,
      payload: {
        plugin: {
          remote,
          app,
          path,
          height,
          disableClose,
          closeEventName
        }
      }
    }));
    this.stream.on(closeEventName, () => {
      onClose === null || onClose === void 0 ? void 0 : onClose();
    });
  }

  close() {
    if (!isWebView()) {
      return this.logger.log('WARN', 'bridge.plugin.close', 'WebView 환경이 아닌 환경에서는 해당 함수를 지원하지 않아요');
    }

    this.driver.postMessage(createMessage({
      type: Type.ReqPluginClose
    }));
  }

  style({
    height,
    disableClose
  }) {
    if (!isWebView()) {
      return this.logger.log('WARN', 'bridge.plugin.style', 'WebView 환경이 아닌 환경에서는 해당 함수를 지원하지 않아요');
    }

    this.driver.postMessage(createMessage({
      type: Type.ReqPluginStyle,
      payload: {
        plugin: {
          height,
          disableClose
        }
      }
    }));
  }

}